import { ContactUsActionTypes } from './constants';
// import { ContactUsAction } from './actions';

type ContactList = {
    contact_id: string;
    seq_id: string;
    label: string;
    value: string;
    icon: File | string;
    linking_url: string;
    created_at: string;
    update_at: string;
};

type ContactAdd = {
    label: string;
    value: string;
    icon: File | string;
    linking_url: string;
};

type ContactUpdateSeq = {
    sequences: {
        contact_id: number;
    };
};

type ContactUsState = {
    loading: boolean;
    contactUs: ContactList[];
    error: string | null;
    message: string | null;
};

const INITIAL_STATE: ContactUsState = {
    loading: false,
    contactUs: [],
    error: null,
    message: null,
};

type ContactUsAction =
    | {
          type: typeof ContactUsActionTypes.CONTACT_LIST;
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_LIST_SUCCESS;
          payload: {
              data: ContactList[];
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_LIST_ERROR;
          payload: {
              error: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_ADD;
          payload: {
              data: ContactAdd;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_ADD_SUCCESS;
          payload: {
              message: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_ADD_ERROR;
          payload: {
              error: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_DELETE;
          payload: {
              contact_id: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_DELETE_SUCCESS;
          payload: {
              message: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_DELETE_ERROR;
          payload: {
              error: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_UPDATE;
          payload: {
              data: ContactAdd;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_UPDATE_SUCCESS;
          payload: {
              message: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_UPDATE_ERROR;
          payload: {
              error: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_UPDATE_SEQ;
          payload: {
              data: ContactUpdateSeq;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_UPDATE_SEQ_SUCCESS;
          payload: {
              message: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_UPDATE_SEQ_ERROR;
          payload: {
              error: string;
          };
      };

const ContactUsReducer = (state = INITIAL_STATE, action: ContactUsAction): ContactUsState => {
    switch (action.type) {
        case ContactUsActionTypes.CONTACT_LIST:
        case ContactUsActionTypes.CONTACT_ADD:
        case ContactUsActionTypes.CONTACT_DELETE:
        case ContactUsActionTypes.CONTACT_UPDATE:
        case ContactUsActionTypes.CONTACT_UPDATE_SEQ:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };

        case ContactUsActionTypes.CONTACT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                contactUs: action.payload.data,
                error: null,
            };

        case ContactUsActionTypes.CONTACT_ADD_SUCCESS:
        case ContactUsActionTypes.CONTACT_UPDATE_SUCCESS:
        case ContactUsActionTypes.CONTACT_UPDATE_SEQ_SUCCESS:
        case ContactUsActionTypes.CONTACT_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                message: action.payload.message,
                error: null,
            };

        case ContactUsActionTypes.CONTACT_LIST_ERROR:
        case ContactUsActionTypes.CONTACT_ADD_ERROR:
        case ContactUsActionTypes.CONTACT_DELETE_ERROR:
        case ContactUsActionTypes.CONTACT_UPDATE_ERROR:
        case ContactUsActionTypes.CONTACT_UPDATE_SEQ_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: null,
            };

        default:
            return state;
    }
};

export default ContactUsReducer;
